import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BaseSidebarComponent } from './core/layout/components/base-sidebar/base-sidebar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, BaseSidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'bcr-tool';
}
